import { createFileRoute } from "@tanstack/react-router";
import React from "react";
import { msalInstance } from "@/auth/msal.ts";

export const Route = createFileRoute("/logout")({
  component: LogoutPage,
});

function LogoutPage() {
  React.useEffect(() => {
    const account = msalInstance.getActiveAccount() ?? undefined;
    const configured =
      msalInstance.getConfiguration().auth.postLogoutRedirectUri;
    const target = configured ?? `${window.location.origin}/login`;

    void msalInstance.logoutRedirect({
      account,
      postLogoutRedirectUri: target,
    });
  }, []);

  return (
    <main className="grid min-h-svh place-items-center p-6">
      <div className="w-80 text-center space-y-2">
        <h1 className="text-xl font-semibold">Melde ab…</h1>
        <p className="text-sm text-muted-foreground">Bitte einen Moment.</p>
      </div>
    </main>
  );
}
